// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../../../internal/PageContentBlock';
import Iframe from '../../../../components/Iframe';

type PropTypes = {|
  pardotFormUrl: string,
|};

export default (props: PropTypes) => {
  return (
    <PageContentBlock background="DefaultContrast" layout="Thin">
      <div className={styles.ctaText}>
        <h2 className={styles.title}>We don&lsquo;t currently have any upcoming events</h2>
        <p className={styles.intro}>
          We&lsquo;re organising events all the time, so watch this page for updates.
          <br />
          Alternatively sign up to our newsletter for regular updates.
          <br />
          You can also read about our past events below.
        </p>
        <Iframe className={styles.subscribe} src={props.pardotFormUrl} />
      </div>
    </PageContentBlock>
  );
};
